<template>
  <div class="form-popup" @click="close()">
    <div class="parent-form-container" @click.stop="">
      <b-overlay :show="showOverlay" class="form-container">
        <header>
          <div class="header-part">
            <span> Création du contrat de bail </span>
            <i class="ik ik-x clos" @click="close()"></i>
          </div>
          <div class="progress-area">
            <div class="step-item">
              <span :class="{ active: step == 0 }"> Habitation </span>
              <div class="bullet" :class="{ active: step == 0 }">
                <span v-show="step == 0">1</span>
                <div v-show="step > 0">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{ active: step == 1 }"> Facturation </span>
              <div class="bullet" :class="{ active: step == 1 }">
                <span v-show="step <= 1">2</span>
                <div v-show="step > 1">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{ active: step == 2 }"> Contrat </span>
              <div class="bullet" :class="{ active: step == 2 }">
                <span v-show="step <= 2">3</span>
                <div v-show="step > 2">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{ active: step == 3 }"> Pièces jointes </span>
              <div class="bullet" :class="{ active: step == 3 }">
                <span v-show="step <= 3">4</span>
                <div v-show="step > 3">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{ active: step == 4 }"> Visualisation </span>
              <div class="bullet" :class="{ active: step == 4 }">
                <span>5</span>
              </div>
            </div>
          </div>
        </header>
        <div class="main-form">
          <section v-show="step == 0" class="process-item habitation">
            <div class="concern-log">
              <div class="concern-log-select">
                <span class="title">Logement</span>
                <!-- <input
                type="text"
                placeholder="selectionner le logement concerné"
              /> -->
                <select v-model="occupation.idLogement" >
                  <option value="">selectionner le logement concerné</option>
                  <option
                    v-for="(log, index) in logements"
                    :key="index"
                    :value="log.idLogement"
                  >
                    {{ log.refLogement }}
                  </option>
                </select>
                <!-- <v-select
                :options="logements"
                v-model="occupation.idLogement"
                :reduce="(logement) => logement.idLogement"
                label="refLogement"
                @input="setSlide_logement"
              >
                <template
                  #option="{ refLogement, sousTypeLogement, prixMin, prixMax }"
                >
                  <b>{{ refLogement }}</b>
                  <br />
                  <span>{{ sousTypeLogement.libelleSousType }}</span>
                  |
                  <span class="text-muted">
                    {{
                      prixMin
                        | currency("F" || "", 0, {
                          symbolOnLeft: false,
                          spaceBetweenAmountAndSymbol: true,
                          thousandsSeparator: " ",
                        })
                    }}
                    -
                    {{
                      prixMax
                        | currency("F" || "", 0, {
                          symbolOnLeft: false,
                          spaceBetweenAmountAndSymbol: true,
                          thousandsSeparator: " ",
                        })
                    }}
                  </span>
                </template>
              </v-select> -->
              </div>
              <div class="concern-log-view">
                <span class="title">Visualisation du logement selectionné</span>
                <div class="concern-log-view-img">
                  <img :src="imgLog" alt="" />
                </div>
              </div>
            </div>
            <div class="concern-hbt">
              <div class="concern-hbt-select">
                <span class="title">Habitant</span>
                <!-- <input
                type="text"
                placeholder="selectionner l'habitant concerné"
              /> -->
                <select v-model="occupation.idLocataire" @change="viewhbt()">
                  <option value="">selectionner l'habitant concerné</option>
                  <option
                    v-for="(hbt, index) in locataires"
                    :key="index"
                    :value="hbt.idLocataire"
                  >
                    {{ hbt.nomLocataire }} {{ hbt.prenomLocataire }}
                  </option>
                </select>

                <!-- <v-select :options="locataires" v-model="occupation.idLocataire" :reduce="locataire => locataire.idLocataire" label="nomLocataire"  @input="setSlide_locataire" :disabled="disabled" >                            
                                        <template #option="{ nomLocataire, prenomLocataire, tel}">
                                            <b>{{ nomLocataire + ' ' + prenomLocataire }}</b>
                                            <br />
                                            <span class="text-muted">{{ tel }}</span>
                                        </template>
                                    </v-select> -->
              </div>
              <div class="concern-hbt-view">
                <span class="title"
                  >Visualisation de l'habitant selectionné</span
                >
                <div class="concern-hbt-block">
                  <div class="avatar">
                    <img :src="imgLoc" alt="" />
                  </div>
                  <div class="hbt-txt">
                    <span>{{ nameLoc }}</span>
                    <span>{{ telLoc }}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section v-show="step == 1" class="process-item facturation">
            <div class="facturation-item">
              <span class="title"> Infos concernant le logement </span>
              <div class="input-container">
                <input
                  type="number"
                  min="0"
                  required
                  placeholder="Loyer par mois"
                  v-model="occupation.loyer"
                />
                <input
                  type="number"
                  min="0"
                  required
                  placeholder="Combien de mois le locataire a t-il avancé"
                  v-model="occupation.avance"
                />
                <input
                  type="number"
                  min="0"
                  required
                  placeholder="somme versée faisant office de caution"
                  v-model="occupation.caution"
                />
                <!-- <input type="number" required placeholder="Date debut du bail" /> -->
                <input type="date" v-model="occupation.debut" />
                <!-- <date-picker
                v-model="occupation.debut"
                :placeholder="
                  $t('data.occupation_form_label_selectionner_date')
                "
                format="dddd, DD MMMM YYYY"
                valueType="YYYY-MM-DD"
                class="date-picker"
                :clearable="false"
              /> -->
              </div>
            </div>
            <div class="facturation-item">
              <span class="title"> Mode de paiement </span>
              <div class="input-container radio">
                <label :class="{ check: occupation.mode == 'postpayer' }">
                  <input
                    type="radio"
                    value="postpayer"
                    v-model="occupation.mode"
                  />
                  <span>Post-payé</span>
                </label>
                <label :class="{ check: occupation.mode == 'prepayer' }">
                  <input
                    type="radio"
                    value="prepayer"
                    v-model="occupation.mode"
                  />
                  <span>Prépayé</span>
                </label>
              </div>
            </div>
            <div class="facturation-item">
              <div class="input-container">
                <div class="index-water">
                  <span class="title">Facturation d'eau</span>
                  <div class="input-container index">
                    <label :class="{ check: occupation.eau == 'forfait' }">
                      <input
                        type="radio"
                        value="forfait"
                        v-model="occupation.eau"
                      />
                      <span>Paiement par forfait</span>
                    </label>
                    <label :class="{ check: occupation.eau == 'index' }">
                      <input
                        type="radio"
                        value="index"
                        v-model="occupation.eau"
                      />
                      <span>Paiement par indexe</span>
                    </label>
                  </div>
                  <div
                    class="input-container"
                    v-show="occupation.eau == 'forfait'"
                  >
                    <input
                      type="number"
                      min="0"
                      style="width: 100%"
                      placeholder="Entrez le taux forfaitaire"
                      v-model="occupation.puEau"
                    />
                  </div>
                  <div
                    class="input-container"
                    v-show="occupation.eau == 'index'"
                  >
                    <input
                      type="number"
                      min="0"
                      placeholder="Prix unitaire par indexe"
                      v-model="occupation.puEau"
                    />
                    <input
                      type="number"
                      min="0"
                      placeholder="Indexe initial"
                      v-model="occupation.indexEau"
                    />
                  </div>
                </div>
                <div
                  class="barre"
                  style="height: 80%; width: 1px; background: #eee"
                ></div>
                <div class="index-water">
                  <span class="title">Facturation électricité</span>
                  <div class="input-container index">
                    <label :class="{ check: occupation.energie == 'forfait' }">
                      <input
                        type="radio"
                        value="forfait"
                        v-model="occupation.energie"
                      />
                      <span>Paiement par forfait</span>
                    </label>
                    <label :class="{ check: occupation.energie == 'index' }">
                      <input
                        type="radio"
                        value="index"
                        v-model="occupation.energie"
                      />
                      <span>Paiement par indexe</span>
                    </label>
                  </div>
                  <div
                    class="input-container"
                    v-show="occupation.energie == 'forfait'"
                  >
                    <input
                      type="number"
                      min="0"
                      style="width: 100%"
                      placeholder="Entrez le taux forfaitaire"
                      v-model="occupation.puEnergie"
                    />
                  </div>
                  <div
                    class="input-container"
                    v-show="occupation.energie == 'index'"
                  >
                    <input
                      type="number"
                      min="0"
                      placeholder="Prix unitaire par indexe"
                      v-model="occupation.puEnergie"
                    />
                    <input
                      type="number"
                      min="0"
                      placeholder="Indexe initial"
                      v-model="occupation.indexEnergie"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section v-show="step == 2" class="process-item contrat">
            <div class="contrat-templates">
              <span class="title">Modèles de contrat prédefinis</span>
              <div class="contrat-container">
                <div
                  class="contrat-item"
                  v-for="(item, index) in contrats"
                  :key="index"
                  @click="contratSelect(item, index)"
                  :class="{ 'active-contrat': selectedContrat == index }"
                >
                  <div class="contrat-icon">
                    <i class="ik ik-file-text"></i>
                  </div>
                  <span>{{ item.libelleModele }}</span>
                </div>
                <!-- <div class="contrat-item">
                <div class="contrat-icon">
                  <i class="ik ik-file-text"></i>
                </div>
                <span>Lorem, ipsum dolor</span>
              </div>
              <div class="contrat-item">
                <div class="contrat-icon">
                  <i class="ik ik-file-text"></i>
                </div>
                <span>Lorem, ipsum dolor</span>
              </div> -->
              </div>
            </div>
            <b-overlay :show="contratLoad" class="editor-container">
              <vue-editor
                v-model="content"
                class="editor"
                id="printMe"
              ></vue-editor>
            </b-overlay>
          </section>
          <section v-show="step == 3" class="process-item join">
            <span class="title"> Ajoutez des pièces </span>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi,
              enim provident pariatur.
            </p>
            <div class="upload-container">
              <label>
                <input
                  type="file"
                  ref="fileEtatDesLieux"
                  @change="selectEtatDesLieuxFile"
                />
                <i class="fas fa-upload fa-2x"> </i>
                <span v-if="fileEtatDesLieux" class="file-name">{{
                  fileEtatDesLieux.name
                }}</span>
                <span class="title"> Etats des lieux d'entrée </span>
              </label>
              <label>
                <input
                  type="file"
                  ref="fileProtocoleAccord"
                  @change="selectProtocoleAccordFile"
                />
                <i class="fas fa-upload fa-2x"> </i>
                <span v-if="fileProtocoleAccord" class="file-name">{{
                  fileProtocoleAccord.name
                }}</span>
                <span class="title"> Protocole d'accord </span>
              </label>
            </div>
          </section>
          <section v-show="step == 4" class="process-item end">
            <span class="title"> Votre contrat de bail est prêt </span>
            <p>
              Cliquer sur créer le contrat de bail pour le prévisualiser.
              Cliquer ensuite sur <b>Imprimer</b> dans la fenetre qui s'ouvrira
              afin d'enregistrer le contrat sous pdf.
            </p>
          </section>
        </div>
        <div class="form-footer">
          <button class="prev-btn" @click="step--">Précédent</button>
          <button v-show="step == 2" @click="openSignature()">
            <i class="ik ik-slack" style="margin-right: 5px"></i> Signer le
            document
          </button>
          <button class="next-btn" v-show="temoin" @click="step++">
            Suivant
          </button>
          <button @click="onComplete('add')" class="next-btn" v-show="step == 4">
            Créer le contrat
          </button>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

Vue.use(VueHtmlToPaper, options);
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
import { mapGetters } from "vuex";
import notif from "@/plugins/notif.js";
import Printer from "@/components/PrinterContrat.vue";
import printJS from "print-js";
const php = require("phpjs");
export default {
  components: {
    DatePicker,
    VueEditor,
    Printer,
  },
  props: {
    locataire: { type: Object },
    provenance: { type: Number, required: true, default: "1" },
    action: { type: String, required: true, default: "edit" },
    editOccupation: { type: Object },
  },
  data: () => ({
    options: {
      penColor: "#000",
    },
    showOverlay:false,
    print: false,
    signState: false,
    contratLoad: false,
    imgLog: "http://app.maisonier.com/img/batiment-default.jpeg",
    imgLoc: "http://localhost:8080/img/profile-picture.jpg",
    nameLoc: "",
    temoin: true,
    telLoc: "",
    nextBtnState: true,
    selectedLog: "",
    selectedHbt: "",
    fileEtatDesLieux: "",
    fileProtocoleAccord: "",
    base64CniAvant: "",
    base64CniArriere: "",
    duree: [null, null],
    selected_index_logement: -1,
    selected_index_locataire: -1,
    selected_value: "",
    temoin: true,
    occupation: {
      loyer: "",
      mode: "prepayer",
      energie: "index",
      eau: "index",
      puEnergie: "",
      puEau: "",
      idLogement: "",
      idLocataire: "",
      debut: "",
      indexEnergie: null,
      indexEau: null,
      avance: null,
      contrats: "",
      dureeBail: 0,
      caution: null,
      contrat: "",
    },
    currentHbt:null,
    modeleContratVide: {
      idModele: 0,
      idUtilisateur: "",
      libelleModele: "Modèle Vide",
      contenu:
        '<h1><br></h1><h1 class="ql-align-center"><strong>CONTRAT DE BAIL</strong></h1>',
    },
    paymentMode: ["Post-payé", "Pre-payé"],
    indexWaterMode: "",
    indexElecMode: "",
    payment: "",
    step: 0,
    contrats: [],
    selectedContrat: 0,
    logements: [],
    locataires: [],
    showOverlay: false,
    requiredLoyer: true,
    requiredAvance: true,
    requiredCaution: true,
    requiredLoyer: true,
    requiredMode: true,
    requiredLogement: true,
    requiredLocataire: true,
    requiredELectricite: true,
    requiredEau: true,
    requiredPuEau: true,
    requiredPuEnergie: true,
    requiredIndex: true,
    logement: null,
    htmlToPdfOptions: {
      margin: [10, 5, 10, 5],

      filename: `contrat_de_bail.pdf`,

      image: {
        type: "jpeg",
        quality: 2,
      },

      enableLinks: false,

      html2canvas: {
        scale: 4,
        logging: true,
        useCORS: false,
      },

      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
    },
    content:
      "<h1 class=\"ql-align-center\"><strong>CONTRAT DE BAIL A USAGE D'HABITATION </strong></h1><p><br></p><p><br></p><h3>	<strong>DESIGNATION DES PARTIES</strong></h3><p><br></p><h3>	<strong><u>LE COMPLEXE INDUSTRIEL DU CAMEROUN en abrégé ( CIC )</u></strong></h3><p>	</p><p>	 siège : <strong>.{{ LOGEMENT_ADRESSE_PAYS}}</strong></p><p>	</p><p>	Représenté par : <strong>.{{  NOM_BAILLEUR }}</strong></p><p>  </p><p>    N° de CNI : <strong>{{  CNI_BAILLEUR }}</strong></p><p><br></p><p>	Date de Délivrance : ....................</p><p><br></p><p>    Tél : <strong>{{  TEL_BAILLEUR }}</strong></p><p><br></p><p>                ci-après désigné  <strong>&lt;&lt; BAILLEUR &gt;&gt;</strong></p><p><br></p><p>																								<strong>ET</strong></p><p><br></p><h3>		</h3><h3>		<strong><u>Le LOCATAIRE</u></strong></h3><p>		</p><p>			 NOM:<strong> {{ LOCATAIRE_NOMS_PRENOMS }}</strong></p><p>	</p><p>			Né 	le : <strong>{{ LOCATAIRE_DATE_NAISSANCE  }}</strong></p><p>  </p><p>  		    Fils de  : ............</p><p><br></p><p>	        Exercant  de: ........</p><p><br></p><p>            N° de CNI: <strong>{{ LOCATAIRE_CNI }}</strong></p><p>		</p><p>			Date de délivrance: .................</p><p><br></p><p>			Tel: <strong>{{ LOCATAIRE_TEL  }}</strong></p><p><br></p><p><strong>carte nationale d'identité :</strong></p><p><img src=\"{{ CNI_AVANT }}\">  <img src=\"{{ CNI_ARRIERE }}\"></p><br><p>ci-après désigné  &lt;&lt; LE PRENEUR&gt;&gt;</p><p><br></p><h2>	</h2><h3>				<strong>IL A ETE ARRETE ET CONVENU CE QUI SUIT</strong></h3><p><br></p><p><br></p><h3>	<strong>Article 1: OBJET-USAGE DES LIEUX</strong></h3><p>	</p><p>	1.1 Le bailleur loue par les présentes au preneur qui accepte les lieux ci-après décrits à l'article 2, situé au quartier Mvan à usage exclusif d'habitation.</p><p><br></p><p>	1.2 Ils ne pourront être utilisé même temporairement à d'autres usages que celui ainsi arrêté sous</p><p>			peine de résiliation de plein droit de bail, suivi d'un délaissement immédiat à la première demande du bailleur&nbsp;.</p><p><br></p><p><br></p><h3>	<strong>Article 2: DESIGNATION-COMPOSITION-ETAT DES LIEUX</strong></h3><p><br></p><p>	2.1 Les locaux objet du présent bail se présentent ainsi qu'il suit :</p><ul><li>		<strong>{{ CARACTERISTIQUES_LOGEMENT }}</strong></li></ul><p><br></p><p>   2.2 Il n'est pas fait plus ample description des lieux loués, le preneur déclarant les connaitre parfaitement pour les avoir vu, visité, et accepté  tels quels avant conclusion du présent contrat</p><p><br></p><p>	2.2 A défaut des lieux ci-dessus, le preneur reconnait  qu'il sera réputé avoir occupé les lieux en parfait état.</p><p><br></p><h3><strong>Article 3: DUREE DU BAIL-AVENANT DE RENOUVELEMENT</strong></h3><p><br></p><p>	3.1 Le présent bail est inclus pour une durée ferme et définitive <strong>{{ CONTRAT_DUREE }}</strong> mois ? Sauf si les parties en disposent autrement</p><p><br></p><p>	3.2 Un mois avant la fin du bail , il est inclus un nouveau bail si nécessaire pour la même durée à la même demande écrite du locataire.</p><p><br></p><p>	3.3 En cas d'acceptation du bailleur ou de son silence garder jusqu'au moins deux semaines avant l'expiration du bail, le renouvellement est acquis et dans tous les cas pour une durée supplémentaire d'un an.</p><p><br></p><h3><strong>Article 4: PRIX DU LOYER ET DES REDEVANCES D'OCCUPATION</strong></h3><p><br></p><p>	 4.1 Le prix du loyer mensuel hors taxes consenti pour la présente location est de : <strong>{{ PRIX_LOYER }} FCFA</strong></p><p>	</p><p>    4.2 Que le preneur accepte payer ainsi que les accessoires, à chaque échéance ci-après indiquée ;</p><p><br></p><p>	4.3 Le loyer est payable mensuellement ;</p><p><br></p><p>	4.4 Le preneur s'oblige à s'acquitter ses loyers et accessoires par terme et d'avance à Yaoundé, au plus tard le premier jour de chaque mois ;</p><p><br></p><p>	4.5 Les paiements tant du loyer que de accessoires seront effectuées par des versements en espèces entre les mains du bailleur ou de tout autre mandataire détenteur d'une bonne et valable procuration ;</p><p><br></p><p><br></p><h3><strong>Article 5: FRAIS D'ETABLISSEMENT, DEPENSES D'ENREGISTREMENT, TIMBRE DE TAXES DIVERSES, ET FRAIS DE POURSUITES </strong></h3><p><br></p><p>5.1 Tous les frais fixés par les règlements publics relatifs à l'établissement de présentes ( frais d'enregistrement, frais de timbre et pénalités de toutes natures), sont   à la charge du preneur;</p><p><br></p><p>5.2 Les taxes fixées par les administrations publiques, communales sont également à sa charge et dues dans les conditions et aux dates fixées par ces administrations ; il devra justifier de leurs acquis avant de déménager ;</p><p><br></p><p>5.3 En cas de règlement tardif de ces taxes par le preneur, les pénalités administratives et fiscales en résultant sont à la charge du preneur;</p><p><br></p><p>5.4 Les frais droits et honoraires auxquels pourront donner lieu le présent acte et ses suites, y compris les frais de poursuites de  toutes natures, seront supportés par le preneur;</p><p><br></p><h3><strong>Article 6: LA CAUTION OU DEPOT DE GARANTIE</strong></h3><p><br></p><p>6.1 Le montant de la caution ou du dépôt de garantie est de : <strong>{{ MONTANT_CAUTION }} FCFA</strong></p><p><br></p><p>6.2 Le preneur a versé la somme de <strong>{{ AVANCE }} FCFA</strong> correspondant à une avance de <strong>{{ NBRE_MOIS }}</strong> mois de loyer.</p><p><br></p><p>6.3 Le dernier terme du loyer ne sera ni imputable sur le dépôt de garantie ; Celui-ci restera conservé à titre de sûreté de bonne exécution du présent bail;</p><p><br></p><p>6.4 Le preneur ne pourra exiger le remboursement de la caution ou du dépôt de garantie en fin de jouissance, dès complet déménagement,  remise de toutes les clés et des lieux en état initial d'occupation ; </p><p><br></p><h3><strong>Article 7: ENTRETIEN TRAVAUX REPARATIONS-REGLEMENTS D'IMMEUBLE</strong></h3><p><br></p><p>7.1 Le preneur entretiendra les lieux loués en bon état de réparation locative, en jouira en bon père de famille et les restituera en fin de bail en bon état.</p><p><br></p><p>7.2 Le preneur devra notamment refaire les badigeons, peinture de boiserie, des murs, portes, plafonnage, etc... conformément aux dispositions de l'article 1 754 code civil aussi souvent que besoin sera ;</p><p><br></p><p>7.3 Le bailleur ne sera tenu d'exécuter au cours du bail que les grosses réparations qui pourraient, conformément aux disposition de l'article 1 720 du code civil, devenir nécessaires, toute autre réparation quelle qu'elle soit restant à chaque charge du preneur qui en supportera les conséquences.</p><p><br></p><h3><strong>Article 8: CESSION DE BAIL SOUS LOCATION</strong></h3><p><br></p><p>8.1 Le présent bail est signé intuitu personnage, toute cession des droits au présent contrat, toute sous location est interdite ;</p><p><br></p><h3><strong>Article 9: REGLEMENT URBAIN</strong></h3><p><br></p><p>9.1 Le preneur satisfera à toutes les prescriptions de police, de voirie et d'hygiène ;</p><p><br></p><h3><strong>Article 10: ASSURANCES-RESPONSABILITES-RECOURS DIVERS</strong></h3><p><br></p><p>10.1 Le preneur est responsable de toutes dégradations commises, et de tous sinistres directs et indirects qui pourraient être survenus par lui, par les occupants de son chef, ou par des tiers quelconques se trouvant même momentanément sur les lieux loués par lui, ou ayant un rapport quelconque avec&nbsp;lui ;</p><p><br></p><p>10.2 Il sera particulièrement responsable et de plein droit, des dégâts causés en cours d'aménagement, ainsi que ceux résultant des activités des personnes effectuant pour son compte des travaux sur les lieux, ou celle des personnes vivants avec lui ;</p><p><br></p><p>10.3 Il renonce à tous recours en responsabilité contre le bailleur, et pourra exiger de ce dernier aucune indemnité, ni diminution de loyer dans les cas ci-après en cas d'interruption dans le service de l'eau, d'électricité, par suite d'accident ou d’événements indépendants de la volonté du bailleur ;</p><p><br></p><p><br></p><h3><strong>Article 11: VISITES-ACCES DES LIEUX-REMISE DES CLES</strong></h3><p><br></p><p>11.1 Le preneur après avoir été au moins vingt quatre (24) heures à l'avance, devra laissé le bailleur ( en personne ou celle de son représentant préposé ) visité les lieux loués chaque fois qu'il le jurera nécessaire, pour tous travaux, relevés, et inspections utiles;</p><p><br></p><p>11.2 Il devra également laisser pénétré les architectures ou entrepreneurs et leur personnel pour tous travaux rendus nécessaires ;</p><p><br></p><p><br></p><h3><strong>Article 12: ELECTRICITE-EAU-TELEPHONE-IMAGETV-INTERNET</strong></h3><p><br></p><p>12.1 Le preneur paiera directement au concessionnaire le montant des abonnement ou consommation d'eau, d'électricité, de téléphone, d'image TV et Internet ; il fera son affaire personnelle;</p><p><br></p><p>12.2 Consommation en eau:&nbsp;&nbsp;Le preneur s'engage à payer la somme de <strong> {{ FORFAIT_EAU }} FCFA </strong> par mois représentant le montant du forfait convenu.</p><p class=\"index_eau\">12.2 Consommation en eau:&nbsp;La consommation en eau du preneur sera calculée chaque mois sur la base des indexes qui seront relevés sur son compteur avec une facturation de <strong> {{ PU_EAU }} le KWh </strong>. A son entrée, l'index relevé est de <strong> {{ INDEX_EAU }}.</strong></p><p>12.3 Consommation en électricité:&nbsp;&nbsp;Le preneur s'engage à payer la somme de <strong>{{ FORFAIT_ELECTRICITE }} FCFA</strong> par mois représentant le montant du forfait convenu.</p><p class=\"index_electricite\">12.3 Consommation en électricité:&nbsp;La consommation en électricité du preneur sera calculée chaque mois sur la base des indexes qui seront relevés sur son compteur électrique avec une facturation de<strong> {{ PU_ELECTRICITE }} le KWh </strong> . A son entrée, l'index relevé est de <strong>{{ INDEX_ELECTRICITE }} . </strong></p><p><br></p><p><br></p><h3><strong>Article 13: TOLERENCES</strong></h3><p><br></p><p>13.1 Toutes tolérances de la part du bailleur, quelles qu'en aient pu être la fréquence et la durée au sujet des clause et conditions du présent accord, ne pourront jamais être considérés comme apportant des modifications ou suppressions de ces clauses et conditions, ni comme génératrice d'un droit quelconque ;</p><p><br></p><h3><strong>Article 14: CLAUSE RESOLUTOIRE - PRIVILEGE DU BAILLEUR</strong></h3><p><br></p><p>14.1 Les parties conviennent expressément que le présent bail sera considéré comme résilié de plein droit et le contrat éteint définitivement pour l'avenir, sans aucune formalité, entre elles dans les hypothèses ci-après :</p><p><br></p><p>&nbsp;&nbsp;&nbsp;a-) En cas du décès du preneur ,</p><p><br></p><p>	 b-) En&nbsp;cas de non paiement à son écheance&nbsp;d'un seul terme de loyer, ou d'une quelconque somme due en vertu des présentes et huit jours après sommation de payer restée infructueuse ;</p><p><br></p><p><br></p><p>14.2 Dans tous les cas de résiliation, sans préjudice des autres voies de droit, le mobilier garnissant les lieux loués, pourra au gré du bailleur, être séquestré sur place ou dans un garde meuble, aux frais, risque et périls sur requête signés par Monsieur le Président du Tribunal de Première Instance de Yaoundé EKOUNOU, à charge de lui en référé en cas de difficultés ;</p><p><br></p><p>&nbsp;&nbsp;&nbsp;</p><p>14.3 Le séquestre du mobilier fait conformément à la clause ci-dessus pourra être levé, soit par accords amiable signés entre les parties, soit à la suite d'une procédure judiciaire définitive de liquidation de l'intégralité des droits du bailleur.</p><p><br></p><p><br></p><p>14.4 En cas de résiliation amiable, les parties acceptent organiser dans les accords écrits particuliers les modalités de liquidation des droits de chacune d'elles, celle-ci pouvant prévoir qu'il soit défalqué la caution ou du dépôt de garantie, indépendamment des loyers, arriérés de loyers et accessoires, les frais de remise des locaux en état, et plus généralement toute somme due,</p><p><br></p><p><br></p><p><br></p><h3><strong>Article 15: DELAISSEMENT FORCE DE L'IMMEUBLE OU EXPULSION</strong></h3><p><br></p><p>	15.1 Après extinction du présent bail, ou en cas d'acquisition définitive de la clause résolutoire, le délaissement forcé de l'immeuble sera poursuivi et exécuté suivant la simple procédure de référé engagé devant le Tribunal de Première Instance de Yaoundé Ekounou ;</p><h2><br></h2><h3><strong>Article 16: OCCUPATION DES LIEUX APRES CESSATION OU RESILIATION DU BAIL</strong></h3><p><br></p><p>	16.1 Au cas où après cessation ou résiliation du bail, et pour quelque cause que ce soient, les lieux ne seraient pas restitués en l'état au bailleur, et libre de toute occupation, il lui sera dû une indemnité contractuelle d'occupation ;</p><h2><br></h2><h3><strong>Article 17: ELECTION DE DOMICILE - ATTRIBUTION DE COMPETENCE</strong></h3><p><br></p><p>	17.1 Pour l'exécution des présentes, les parties font élection de domicile à leur adresse respective à Yaoundé</p><p><br></p><p>	17.2 A défaut d'accords écrit particuliers amiables terminant tout litige entre les parties en cours d'exécution du présent bail, le président du Tribunal de Première Instance de Yaoundé Ekounou ou tout juge délégué par lui, siègent en chambre de conseil, ou en matière d'urgence est la juridiction contractuelle unique pour trancher tout différend né entre les parties;</p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>",
  }),
  watch: {
    selected_index_logement(value) {
      const logement = this.logements[value];
      this.logement = logement;
      this.occupation.idLogement = logement.idLogement;
      this.indexEnergie = logement.lastIndexEnergie
        ? logement.lastIndexEnergie.nouveau
        : 0;
      this.indexEau = logement.lastIndexEau ? logement.lastIndexEau.nouveau : 0;
    },
    // step(){
    //     if (this.step == 4) {
    //         return this.temoin = false
    //     }else if(this.step == 2 && this.nextBtnState) {
    //         return this.temoin = false
    //     }else{
    //       return this.temoin = true
    //     }
    // },
    nextBtnState() {
      if (!this.nextBtnState) {
        this.temoin = true;
      }
    },
    selected_index_locataire(value) {
      this.occupation.idLocataire = this.locataires[value].idLocataire;
      /*this.base64CniAvant=this.getBase64(this.locataires[value].cniRecto)
        this.base64CniArriere=this.getBase64(this.locataires[value].cniVerso)*/
      console.log("cni avant", this.locataires[value].cniRecto);
      console.log("cni arrière", this.locataires[value].cniVerso);
    },
    loyer(value) {
      if (this.editOccupation == null && this.editOccupation == "") {
        this.occupation.loyer = value;
      }
    },
    selectedLog(){
        let currentLog = this.logements.filter(log => log.idLogement = this.selectedLog)
        console.log(currentLog);
        // this.imgLog = currentLog.photos[0].image
        this.imgLog = currentLog.photos[0].image
    }
  },
  computed: {
    logementSelected() {
      return this.logements.find(
        (elt) => elt.idLogement == this.occupation.idLogement
      );
    },
    loyer: {
      get() {
        const logement = this.logementSelected;
        if (!logement) {
          return 0;
        }
        return logement.prixMax;
      },
      set(value) {
        this.occupation.loyer = value;
      },
    },
    indexEnergie: {
      get() {
        const logement = this.logementSelected;
        if (logement && logement.lastIndexEnergie) {
          return logement.lastIndexEnergie.nouveau;
        }
        return 0;
      },
      set(value) {
        this.occupation.indexEnergie = value;
      },
    },
    indexEau: {
      get() {
        const logement = this.logementSelected;
        if (logement && logement.lastIndexEau) {
          return logement.lastIndexEau.nouveau;
        }
        return 0;
      },
      set(value) {
        this.occupation.indexEau = value;
      },
    },
    ...mapGetters(["user"]),
    devise() {
      return this.user.preferences.devise || "F";
    },
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      // alert("Open DevTools see the save data.");
      console.log(isEmpty);
      console.log(data);
    },
    close() {
      this.$emit("closeBailModal");
      this.step = 0;
    },
    viewlog() {
     let currentLog = this.logements.filter(
        (log) => log.idLogement == this.selectedLog
      );
      console.log(currentLog);
    // this.imgLog = currentLog[0].photos[0].image;
      this.imgLog = currentLog[0].photos[0].image;
    },
    selectProtocoleAccordFile() {
      console.log("entrée 1");
      this.fileProtocoleAccord = this.$refs.fileProtocoleAccord.files[0];
    },
    selectEtatDesLieuxFile() {
      console.log("entrée 2");
      this.fileEtatDesLieux = this.$refs.fileEtatDesLieux.files[0];
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    viewhbt() {
      console.log('hihihhi',this.occupation.idLocataire);
      this.currentHbt = this.locataires.filter(
        (hbt) => hbt.idLocataire == this.occupation.idLocataire
      );
      console.log(this.currentHbt);
      this.imgLoc = this.currentHbt[0].avatar;
      this.nameLoc =
        this.currentHbt[0].nomLocataire + " " + this.currentHbt[0].prenomLocataire;
      this.telLoc = this.currentHbt[0].tel;
    },
    contratSelect(item, index) {
      this.contratLoad = true;
      this.selectedContrat = index;
      console.log(item);
      setTimeout(() => {
        this.contratLoad = false;
        this.content = this.fillData(item.contenu);
      }, 2000);
    },
    getAdresse(logement, key) {
      if (!php.empty(logement.adresse)) {
        return logement.adresse[key];
      }
      if (!php.empty(logement.batiment)) {
        if (!php.empty(logement.batiment.adresse)) {
          return logement.batiment.adresse[key];
        }
      }
      return "..............";
    },
    fillData(content) {
      //let logementSelect = this .logements.find(x => x.idLogement === this.occupation.idLogement) 178722
      let logementSelect = this.logement;
      let locataireSelect = this.currentHbt[0];
      this.locataireName =
        locataireSelect.nomLocataire + " " + locataireSelect.prenomLocataire;
      console.log("logementSelect", logementSelect.caracteristiques);
      let caract = "";
      for (let i = 0; i < logementSelect.caracteristiques.length; i++) {
        let nbre;
        if (
          logementSelect.caracteristiques[i].valeur == "" ||
          logementSelect.caracteristiques[i].valeur == null
        ) {
          nbre = 1;
        } else {
          nbre = logementSelect.caracteristiques[i].valeur;
        }
        caract =
          caract +
          nbre +
          "-" +
          logementSelect.caracteristiques[i].libelleCaracteristique +
          "(s) ,";
      }
      let ancienContent = content;
      let newContent = ancienContent
        .replace(
          "{{  NOM_BAILLEUR }}",
          this.user.profil.titre +
            ". " +
            this.user.nom +
            " " +
            this.user.prenom || ".............."
        )
        .replace(
          "{{  CNI_BAILLEUR }}",
          this.user.profil.cni || ".............."
        )
        .replace("{{  TEL_BAILLEUR }}", this.user.tel || "..............")
        .replace(
          "{{ LOGEMENT_ADRESSE_PAYS}}",
          this.getAdresse(logementSelect, "pays")
        )
        .replace(
          "{{ LOCATAIRE_NOMS_PRENOMS }}",
          locataireSelect.titre + " " + this.nameLoc
        )
        .replace(
          "{{ LOCATAIRE_DATE_NAISSANCE  }}",
          locataireSelect.dateNaiss || "............."
        )
        .replace(
          "{{ LOCATAIRE_CNI }}",
          locataireSelect.cniLocataire || "............."
        )
        .replace(
          "{{ LOCATAIRE_TEL  }}",
          locataireSelect.tel || ".............."
        )
        .replace(
          "{{ CONTRAT_DUREE }}",
          this.occupation.dureeBail || "............."
        )
        .replace("{{ PRIX_LOYER }}", this.occupation.loyer || ".............")
        .replace(
          "{{ MONTANT_CAUTION }}",
          this.occupation.caution || "............."
        )
        .replace(
          "{{ AVANCE }}",
          this.occupation.avance * this.occupation.loyer || "............."
        )
        .replace("{{ CARACTERISTIQUES_LOGEMENT }}", caract)
        .replace("{{ NBRE_MOIS }}", this.occupation.avance || ".............")
        .replace(
          "{{ LOGEMENT_ADRESSE_QUARTIER }}",
          this.getAdresse(logementSelect, "quartier")
        )
        .replace(
          "{{ LOGEMENT_ADRESSE_VILLE }}",
          this.getAdresse(logementSelect, "ville")
        )
        .replace(
          "{{ LOGEMENT_ADRESSE_VILLE }}",
          this.getAdresse(logementSelect, "ville")
        )
        .replace(
          "{{ LOGEMENT_ADRESSE_QUARTIER }}",
          this.getAdresse(logementSelect, "quartier")
        )

        .replace(
          "{{ CNI_AVANT }}",
          this.base64CniAvant || "ajouter photo cni avant"
        )
        .replace(
          "{{ CNI_ARRIERE }}",
          this.base64CniArriere || "ajouter photo cni arriere"
        )

        .replace(
          "{{ REF_LOGEMENT }}",
          logementSelect.refLogement || "............."
        );
      console.log("debug3");
      let p1 = document.querySelector(".forfait_eau");
      let p2 = document.querySelector(".index_eau");
      let p3 = document.querySelector(".forfait_electricite");
      let p4 = document.querySelector(".index_electricite");
      console.log("debug4");
      console.log("p1", p1);
      console.log("p2", p2);
      console.log("p3", p3);
      console.log("p4", p4);
      if (this.occupation.eau == "index") {
        if (p1 != null && p1 != undefined) {
          console.log("entreé index ok 1");
          newContent = newContent
            .replace(p1.innerHTML, "")
            .replace("{{ PU_EAU }}", this.occupation.puEau || ".............")
            .replace(
              "{{ INDEX_EAU }}",
              this.occupation.indexEau || "............."
            );
        }
      }
      if (this.occupation.eau == "forfait") {
        if (p2 != null && p2 != undefined) {
          newContent = newContent
            .replace(p2.innerHTML, "")
            .replace(
              "{{ FORFAIT_EAU }}",
              this.occupation.puEau || "............."
            );
          console.log("contenu p2", p2.innerHTML || ".............");
        }
      }
      if (this.occupation.energie == "index") {
        if (p3 != null && p3 != undefined) {
          console.log("entréee index ok 2");
          newContent = newContent
            .replace(p3.innerHTML, "")
            .replace(
              "{{ PU_ELECTRICITE }}",
              this.occupation.puEnergie || "............."
            )
            .replace(
              "{{ INDEX_ELECTRICITE }}",
              this.occupation.indexEnergie || "............."
            );
          console.log("contenu p3", p3.innerHTML);
        }
      }
      if (this.occupation.energie == "forfait") {
        if (p4 != null && p4 != undefined) {
          newContent = newContent
            .replace(p4.innerHTML, "")
            .replace(
              "{{ FORFAIT_ELECTRICITE }}",
              this.occupation.puEnergie || "............."
            );
          console.log("contenu p4", p4.innerHTML);
        }
      }
      return newContent;
    },
    //validation formulaire d'ajout/modification d'ajout d'une occupation
    async onComplete(action) {
      const formData = new FormData();
      formData.append("etatDeLieuEntree", this.fileEtatDesLieux);
      formData.append("protocoleAccord", this.fileProtocoleAccord);
      $;
      this.occupation.contrat = this.content;
      if (this.occupation.eau == "index") {
        // this.occupation.puEau=this.user.preferences.puEau
      }
      if (this.occupation.energie == "index") {
        // this.occupation.puEnergie=this.user.preferences.puEnergie
      }
      for (const key in this.occupation) {
        formData.append(key, this.occupation[key]);
      }

      if (action == "add") {
        this.showOverlay = true;
        //return console.log('formdata ',formData);
        axios
          .post("occupations", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.$emit("occupationAdded");
            this.resetModal();
            console.log(response);
            this.showOverlay = false;
            this.close();
            return App.notifySuccess(response.message);
          })
          .catch((error) => {
            if (error.code == 430) {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.$t("data.occupation_upgrade_formule"),
                showConfirmButton: true,
                showDenyButton: true,
                confirmButtonText: this.$t("data.occupation_upgrade"),
                denyButtonText: this.$t("data.occupation_cancel"),
                confirmButtonColor: "#f5365c",
                denyButtonColor: "#212121",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$emit("budgetAtteint");
                } else if (result.isDenied) {
                  this.$emit("cancelForm");
                }
              });
            } else if (error.code == 406) {
              return App.notifySuccess(error.message);
            } else if (error.code == 500) {
              return App.notifySuccess(error.message);
            }

            this.showOverlay = false;
          });
      }
      if (action == "edit") {
        console.log("edition", this.occupation.contrat);
        axios
          .put(`occupations/${this.editOccupation.idOccupation}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (!response.success) {
              this.showOverlay = false;
              return App.alertError(response.message);
            }
            console.log("result", response.result);
            this.resetModal();
            this.showOverlay = false;
            //this.editOccupation=null;
            this.$emit("editOccupation", response.result);
            return App.notifySuccess(response.message);
          })
          .catch((error) => {
            this.showOverlay = false;
            notif.error(error.message);
          });
      }
    },
    /**emission évènement pour fermer le formulaire
     * de création d'une annonce et basculer à la création préalable d'un logement
     */
    createLogement() {
      this.$emit("createLogementSecond");
    },
    /**emission évènement pour fermer le formulaire de création d'une occupation
     *  et basculer à la création préalable d'un locataire
     */
    createLocataire() {
      this.$emit("createLocataire");
    },
    openSignature() {
      this.$emit("openSignature");
    },
    async printHtmlToPdf() {
      // Pass the element id here
      await this.$htmlToPaper("printMe");
    },

    setPrintNew() {
      printJS("printJS-form", "html");
    },
    setPrint() {
      this.print = true;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress(event) {
      console.log("event", event);
    },
    hasStartedGeneration() {
      console.log("enter has started generation");
    },
    hasGenerated(event) {
      console.log("methods has generared pdf", event);
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      console.log("entrée before dowload");
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          console.log("totalPages", totalPages);
          for (let i = 1; i <= totalPages; i++) {
            console.log("i", i);
            pdf.setPage(i);
            pdf.setFontSize(12);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " sur " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 2.9
            );
          }
        })
        .save();
    },

    /**
     * Set l'image du carousel lorsqu'on change le logement
     */
    setSlide_logement(value) {
      for (let index = 0; index < this.logements.length; index++) {
        const logement = this.logements[index];
        this.logement = logement;
        if (logement.idLogement == value) {
          this.$refs.logementCarousel.setSlide(index);
          this.occupation.idLogement = logement.idLogement;
          this.occupation.loyer = logement.prixMax;
          this.occupation.caution = (logement.prixMin + logement.prixMax) / 2;
          this.occupation.indexEnergie = logement.lastIndexEnergie
            ? logement.lastIndexEnergie.nouveau
            : 0;
          this.occupation.indexEau = logement.lastIndexEau
            ? logement.lastIndexEau.nouveau
            : 0;

          break;
        }
      }
    },
    setSlide_locataire(value) {
      for (let index = 0; index < this.locataires.length; index++) {
        if (this.locataires[index].idLocataire == value) {
          this.locataireSelect = this.locataires[index];
          this.$refs.locataireCarousel.setSlide(index);
          break;
        }
      }
    },
    async getInitialiseData() {
      this.showOverlay = true;
      try {
        this.logements = await axios
          .get("logements?free=true")
          .then((response) => response.result || []);
        if (!php.empty(this.editOccupation)) {
          this.logements = [this.editOccupation.logement, ...this.logements];
        }
        if (this.logements[0]) {
          const logement = this.logements[0];
          this.logement = logement;
          this.occupation.loyer = logement.prixMax;
          this.occupation.caution = (logement.prixMin + logement.prixMax) / 2;
          this.occupation.indexEnergie = logement.lastIndexEnergie
            ? logement.lastIndexEnergie.nouveau
            : 0;
          this.occupation.indexEau = logement.lastIndexEau
            ? logement.lastIndexEau.nouveau
            : 0;
          this.occupation.idLogement = logement.idLogement;
        }
      } catch (error) {
        notif.error(error.message);
      }
      if (this.provenance != 2) {
        try {
          this.locataires = await axios
            .get("locataires-simples")
            .then(
              (response) =>
                response.result.sort((a, b) =>
                  a.nomLocataire > b.nomLocataire
                    ? 1
                    : b.nomLocataire > a.nomLocataire
                    ? -1
                    : 0
                ) || []
            );
          if (this.locataires[0]) {
            this.occupation.idLocataire = this.locataires[0].idLocataire;
          }
        } catch (error) {
          notif.error(error.message);
        }
      }
      this.contrats = await axios
        .get("modeles-contrats")
        .then((response) => response.result || []);
      this.contrats.push(this.modeleContratVide);
      if (this.contrats.length > 0) this.content = this.contrats[0].contenu;
      this.showOverlay = false;
    },
    //reinitialisation du formulaire de création d'une occupation
    resetModal() {
      console.log("entrée début reinitialisation");
      this.occupation = {
        loyer: null,
        mode: null,
        energie: "index",
        eau: "index",
        puEnergie: null,
        puEau: null,
        idLogement: null,
        idLocataire: null,
        debut: null,
        indexEnergie: 0,
        indexEau: 0,
        avance: 1,
        contrats: null,
        dureeBail: 0,
        caution: 1,
      };
      console.log("entrée fin reinitialisation");
      this.action = "edit";
      this.$emit("closeOccupationModal");
    },
  },
  async mounted() {
    console.log(this.user);
    await this.getInitialiseData();
    this.$root.$on("sign", (signatures) => {
      this.signState = true;
      this.nextBtnState = false;
      console.log("evenement passé");
      this.content +=
        '<img src="' +
        signatures[0] +
        '" width="130"><p>' +
        this.user.nom +
        " " +
        this.user.prenom +
        '</p><img src="' +
        signatures[1] +
        '" width="130"><p>' +
        this.nameLoc +
        "</p>";
    });
    if(this.editOccupation){
            console.log("provenance = édition", this.editOccupation)
           this.occupation.idLogement= this.editOccupation.idLogement; 
           this.occupation.idLocataire= this.editOccupation.idLocataire;

            this.setSlide_logement(this.occupation.idLogement)
           this.setSlide_locataire(this.occupation.idLocataire)

           this.occupation.loyer=this.editOccupation.loyerBase; 
           console.log('loyer',this.occupation.loyer);
           this.occupation.caution=this.editOccupation.caution; 
           this.occupation.mode=this.editOccupation.modePaiement; 
           this.occupation.debut=this.editOccupation.dateDeb; 
           this.occupation.energie=this.editOccupation.modeEnergie; 
           this.occupation.eau=this.editOccupation.modeEau; 
           this.occupation.puEnergie=this.editOccupation.puEnergie; 
           this.occupation.puEau=this.editOccupation.puEau; 
           this.occupation.dureeBail=this.editOccupation.dureeBail; 

           this.$refs['occupationForm'].activateAll();
       }
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  font-size: 1rem;
}
.form-popup {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9999;
}
.parent-form-container{
  height: 90%;
  max-height: 700px;
  width: 70%;
  max-width: 1000px;
  background: white;
  border-radius: 8px;

}
.form-popup .form-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: white;
  border-radius: 8px;
}
.form-container header {
  padding: 0 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 160px;
  border-bottom: 1px solid #eee;
}
.form-container header .header-part {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}
.header-part span {
  font-weight: bold;
  font-size: 1.5rem;
}
.header-part .clos {
  font-size: 1.8rem;
  color: #191c22;
  cursor: pointer;
}
header .progress-area {
  margin-top: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}
.progress-area .step-item {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: auto;
  height: auto;
  user-select: none;
  cursor: pointer;
}
.step-item span {
  font-weight: 500;
  color: #424242;
}
.step-item span.active {
  color: #f5365c;
}
.step-item .bullet {
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 1px solid #424242;
  overflow: visible;
}
.step-item .bullet span {
  font-size: 0.9rem;
  font-weight: bold;
  text-align: center;
  color: #424242;
}
.step-item .bullet div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background: #424242;
}
.step-item .bullet div i {
  color: white;
  font-size: 1.2rem;
}
.bullet.active {
  border: 1px solid #f5365c;
}
.bullet.active span {
  color: #f5365c;
}
.step-item .step .bullet:before,
.step-item .step .bullet:after {
  position: absolute;
  content: "";
  bottom: 11px;
  right: -51px;
  height: 3px;
  width: 44px;
  background: #191c22;
}
.form-container .form-footer {
  padding: 0 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  border-top: 1px solid #eee;
}
.form-footer button {
  padding: 0px 35px;
  height: 45px;
  border-radius: 4px;
  font-weight: bold;
  border: 1px solid #f5365c;
  color: white;
  background: #f5365c;
  transition: 0.3s ease all;
}
.form-footer button:nth-child(1) {
  color: #f5365c;
  background: transparent;
}
.form-footer button:nth-child(2) {
  color: white;
  background: #191c22;
  border-color: #191c22;
}
.form-container .main-form {
  display: flex;
  align-items: center;
  width: 100%;
  height: calc(100% - 240px);
}
.process-item {
  padding: 0 5%;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  transition: 0.3s ease all;
}
.process-item.habitation .concern-log {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48%;
  height: 100%;
}
.concern-log .concern-log-select,
.concern-hbt .concern-hbt-select {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.concern-log-select span,
.concern-log-view span,
.concern-hbt-select span {
  font-size: 1rem;
  color: #424242;
}
.concern-log-select input,
.concern-log-select select,
.concern-hbt-select input,
.concern-hbt-select select {
  padding-left: 5px;
  margin-top: 10px;
  width: 80%;
  height: 45px;
  border: 1px solid #eee;
  outline: none;
  background: transparent;
  border-radius: 8px;
}
.concern-log-view {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.concern-log-view .concern-log-view-img {
  margin-top: 20px;
  width: 80%;
  height: 180px;
  background: #ddd;
  border-radius: 8px;
}
.concern-log-view .concern-log-view-img img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
}
.process-item.habitation .concern-hbt {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48%;
  height: 100%;
}
.concern-hbt-view {
  margin-top: 30px;
  width: 100%;
  height: 180px;
}
.concern-hbt-view .concern-hbt-block {
  margin-top: 20px;
  display: flex;
  width: 100%;
  height: 180px;
}
.concern-hbt-block .avatar {
  height: 100%;
  width: 40%;
  border-radius: 8px;
  background: #eee;
}
.concern-hbt-block .avatar img {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
}
.concern-hbt-block .hbt-txt {
  padding-left: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  height: 100%;
}
.concern-hbt-view span {
  margin-top: 10px;
  color: #424242;
}
.process-item.facturation {
  padding: 30px 5%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.facturation-item {
  margin-bottom: 30px;
}
.input-container {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
}
.title {
  font-weight: 600;
}
.input-container input {
  padding: 0 5px;
  margin-bottom: 15px;
  height: 45px;
  width: 45%;
  border: 1px solid #eee;
  border-radius: 8px;
}
.input-container .date-picker {
  margin: 0 0 15px;
  height: 45px;
  width: 45%;
  border-radius: 8px;
}
.input-container.radio label,
.input-container.index label {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 45%;
  background: transparent;
  background: #f0f0f0;
  border-radius: 8px;
}
.input-container.radio label.check,
.input-container.index label.check {
  background: #191c22;
  color: white;
}
.input-container.radio label input {
  display: none;
}
.input-container .index-water {
  display: flex;
  flex-direction: column;
  width: 48%;
  height: auto;
}
.input-container .index-water input[type="radio"] {
  display: none;
}
.process-item.contrat {
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  overflow-y: auto;
}
.process-item.contrat .contrat-templates {
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 150px;
}
.contrat-templates .contrat-container {
  display: flex;
  /* justify-content: space-between; */
  height: 60px;
  width: 100%;
}
.contrat-container .contrat-item {
  padding: 0 25px 0 15px;
  margin: 10px 20px 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
  width: auto;
  border-radius: 8px;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.contrat-item .contrat-icon {
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  /* width: 50px; */
  font-size: 1.5rem;
}
.contrat-item span {
  font-weight: 500;
  font-size: 1rem;
}
.process-item.contrat .editor-container {
  margin-top: 30px;
  margin-right: 2%;
  height: calc(100% - 90px);
  width: 98%;
  overflow-y: auto;
}
.editor-container .editor {
  height: auto;
  width: 98%;
}
.process-item.join {
  padding-top: 30px;
  flex-direction: column;
  justify-content: flex-start;
}
.process-item.join .title {
  margin-top: 10px;
}
.process-item.join .upload-container {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.process-item.join p {
  margin-top: 10px;
}
.upload-container label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #efefef;
  height: 10rem;
  width: 46%;
  border-radius: 8px;
}
.upload-container label input {
  display: none;
}
.upload-container label i {
  margin-bottom: 15px;
  color: #424242;
}
.contrat-item.active-contrat {
  background: #eee;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.process-item.end {
  padding: 0 5%;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
.process-item.end .title {
  font-weight: 600;
  font-size: 1.2rem;
  text-align: center;
}
.process-item.end p {
  margin-top: 1.2rem;
  text-align: center;
  width: 80%;
  max-width: 600px;
  color: #424242;
}
</style>
